module.exports = __webpack_public_path__ + "static/media/low_shelf_freq.f51fc34c.png";